<template>
  <a-form-item
    :label="varLabel"
    :label-col="formItemLayout.labelCol"
    :wrapper-col="formItemLayout.wrapperCol"
  >
    <a-select
      :disabled="disabled"
      v-decorator="[
                    `${varName}`,
                    { rules: [{ required: true, message: message }],
                    initialValue: varInitial
                    }]"
      :mode="varMode"
    >
      <template v-if="type === 'schema'">
      <a-select-option v-for="d in varOptions" :key="d.value">{{d.display_name}}</a-select-option>
      </template>
      <template v-else-if="type === 'array'">
      <a-select-option v-for="d in varOptions" :key="d">{{d}}</a-select-option>
      </template>
    </a-select>
    <a-alert :message="description" type="info" showIcon style="margin-top:5px;" v-if="description" />
  </a-form-item>
</template>

<script>
import { formLayoutMixin } from "@/mixins/formLayout";

export default {
  mixins: [formLayoutMixin],
  props: {
    varName: String,
    varLabel: String,
    varInitial: [String, Array],
    varRequired: Boolean,
    formLayout: String,
    size: String,
    varMode: {
      type: String,
      default: "default"
    },
    varOptions: Array,
    description: [String, null],
    disabled: {
      type: Boolean,
      default: false
    },
    type: String
  },
  computed: {
    message() {
      return `Please enter ${this.varLabel.toLowerCase()}`;
    }
  }
};
</script>
